const FOPLink = document.querySelectorAll('[data-fop-link]');
console.log(FOPLink, 'FOPLINKS');
FOPLink.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault(); 
    const parent = link.closest('.product-single__meta'); 
    const selector = parent.querySelector('[name="id"]'); 
    const variantId = parseInt(selector.value);
    const variantTitle = selector.options[selector.selectedIndex] ? selector.options[selector.selectedIndex].text : selector.options[0]; 
    const productInfo = link.querySelector('[data-product-variants]');
    const jsonData = productInfo.textContent;
    const parsedData = JSON.parse(jsonData); 
    const y = window.scrollY;
    localStorage.setItem('savedPosition', y);

    const foundVariant = parsedData.variants.find(
      (variant) => variant.title === variantTitle
    );

    if (foundVariant) {
      window.location = `/products/${parsedData.handle}?variant=${foundVariant.id}`;
    } else {
      window.location = event.target.href;
    }
  });
});
